export default {
    // 查询授权信息接口
    listRegisterInfo(params, response) {
        window.vue.$apiAxios.get('/licenseserver/licenseAuthorizeController/listRegisterInfo', params, response);
    },
    // 授权码认证接口
    registerCodeEmpower(params, response) {
        window.vue.$apiAxios.postRequestBody('/licenseserver/licenseAuthorizeController/registerCodeEmpower', params, response);
    },

    // 查询所有授权信息
    getAllLicenseInfo(params, response) {
        window.vue.$apiAxios.get('/licenseserver/licenseAuthorizeController/getAllLicenseInfo', params, response);
    },

    // 查询硬件序列号
    getHardwareSerialNumberInfo(params, response) {
        window.vue.$apiAxios.get('/licenseserver/licenseAuthorizeController/hardwareSerialNumber', params, response);
    },
    // 在线反注册
    onlineUnRegister(params, response) {
        window.vue.$apiAxios.postRequestBody('/licenseserver/licenseAuthorizeController/onlineUnRegister', params, response);
    },

    // 在线认证
    getOnlineAuthentication(params, response) {
        window.vue.$apiAxios.postRequestBody('/licenseserver/licenseAuthorizeController/onlineAuthentication', params, response);
    },
    // 导入
    offlineUnRegister(params, response) {
        window.vue.$apiAxios.postRequestBody('/licenseserver/licenseAuthorizeController/offlineUnRegister', params, response);
    }
};
